export class RegroupementPlatML {
  id : number;
  idsUniteDeProduction : number[];
  idSite : number;
  libelle : string;
}
